import { render } from "./IconOpenInNew.vue?vue&type=template&id=2e1ed135"
const script = {}
script.render = render

export default script